import { useContext } from "react";
import { MapContext } from "@/context/mapContext";
/**
 * Custom hook to access the map context
 * @returns {MapContextProps} The map context values
 */
export function useMapContext() {
  const context = useContext(MapContext);
  if (!context)
    throw new Error("useMapContext must be used within a MapProvider");
  return context;
}
